import React from "react";
import { InterviewNodePropsShape } from "../../interfaces/componentTypes";

export const InterviewNode: React.FunctionComponent<InterviewNodePropsShape> = ({
  set,
  handleRemove,
}) => {
  const handleRemoveInterviewClick = (e) => {
    e.preventDefault();
    handleRemove(set);
  };
  return (
    <div className="goal-form-input-row">
      <div className="interview-node-wrapper">
        <div className="goal-display-field">
          <span>{set.name()}</span>
        </div>
        <div>
          <button
            className="interview-node-delete"
            onClick={handleRemoveInterviewClick}
          >
            <i
              style={{ bottom: "10%" }}
              className="icon-delete delete-icon"
            ></i>
          </button>
        </div>
      </div>
    </div>
  );
};
